<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="program_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">PROGRAM INFORMATION</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>
    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('noble_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('noble_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P003'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="3" :thumb-slide-width="60" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div>{{ $t('noble_desc1') }}</div>
          <div>{{ $t('noble_desc2') }}</div>
          <div>{{ $t('noble_desc3') }}</div>
          <div>{{ $t('noble_desc4') }}</div>
          <div>{{ $t('noble_desc5') }}</div>
          <div>{{ $t('noble_desc6') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('noble_common_title') }}</div>
          <div class="subDatail">
            <div>{{ $t('noble_common_desc1') }}</div>
            <!--            <div>{{ $t('noble_common_desc2') }}</div>
            <div>{{ $t('noble_common_desc3') }}</div>-->
            <!--            <div>{{ $t('noble_common_desc4') }}</div>-->
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('noble_main_title') }}</div>
          <div class="row d-flex">
            <div v-for="(item, index) in sub_items" :key="index" class="col-lg-4 col-12 mb-4">
              <template>
                <div class="card">
                  <a :href="item.href">
                    <img class="card-img-top" :src="item.image" alt="Card image cap" style="padding: 10px"
                  /></a>
                  <div class="card-body">
                    <h5 class="card-title" style="letter-spacing: -0.02rem">{{ $t(item.title) }}</h5>
                    <p class="card-text" style="font-size: 0.8rem; word-break: keep-all; height: 5rem">
                      {{ $t(item.desc) }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <!--          <div class="subDatail">-->
          <!--            <div>1. 실내&실외 승마 : 정통승마강습(30분) + 야외트랙 탑승(30분) ※월요일 휴관</div>-->
          <!--            <div>2. 실내 승마 : 정통승마강습(60분)</div>-->
          <!--            <div>3. 키즈 승마 : 전문 교관과 함께하는 포니(Pony) 탑승(60분) ※보호자 동반 필수</div>-->
          <!--            <div>※ 현장 상황 및 개인 기량에 따라 코스는 변경될 수 있습니다.</div>-->
          <!--          </div>-->
          <div class="rowSpace"></div>

          <table class="web table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('noble_table1_tr1_td1') }}</td>
                <td>{{ $t('noble_table1_tr1_td2') }}</td>
                <td>{{ $t('noble_table1_tr1_td3') }}</td>
                <td>{{ $t('noble_table1_tr1_td4') }}</td>
                <td>{{ $t('noble_table1_tr1_td5') }}</td>
                <td>{{ $t('noble_table1_tr1_td6') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('noble_table1_tr2_td1') }}</td>
                <td>{{ $t('noble_table1_tr2_td2') }}</td>
                <td rowspan="2">{{ $t('noble_table1_tr2_td3') }}</td>
                <td>{{ $t('noble_table1_tr2_td4') }}</td>
                <td>{{ $t('noble_table1_tr2_td5') }}</td>
                <td rowspan="2">{{ $t('noble_table1_tr2_td6') }}</td>
              </tr>
              <tr>
                <td>{{ $t('noble_table1_tr3_td1') }}</td>
                <td>{{ $t('noble_table1_tr3_td2') }}</td>
                <td rowspan="2">{{ $t('noble_table1_tr3_td3') }}</td>
                <td>{{ $t('noble_table1_tr3_td4') }}</td>
              </tr>
              <!--              <tr>
                <td>{{ $t('noble_table1_tr4_td1') }}</td>
                <td>{{ $t('noble_table1_tr4_td2') }}</td>
                <td>{{ $t('noble_table1_tr4_td3') }}</td>
                <td>{{ $t('noble_table1_tr4_td4') }}</td>
              </tr>-->
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td1') }}</td>
                <td>{{ $t('noble_table1_tr2_td1') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td2') }}</td>
                <td>{{ $t('noble_table1_tr2_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td3') }}</td>
                <td>{{ $t('noble_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td4') }}</td>
                <td>{{ $t('noble_table1_tr2_td4') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td5') }}</td>
                <td>{{ $t('noble_table1_tr2_td5') }}</td>
              </tr>
              <tr>
                <td class="subTable3">{{ $t('noble_table1_tr1_td6') }}</td>
                <td>{{ $t('noble_table1_tr2_td6') }}</td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td1') }}</td>
                <td>{{ $t('noble_table1_tr3_td1') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td2') }}</td>
                <td>{{ $t('noble_table1_tr3_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td3') }}</td>
                <td>{{ $t('noble_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td4') }}</td>
                <td>{{ $t('noble_table1_tr3_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td5') }}</td>
                <td>{{ $t('noble_table1_tr3_td4') }}</td>
              </tr>
              <tr>
                <td class="subTable3">{{ $t('noble_table1_tr1_td6') }}</td>
                <td>{{ $t('noble_table1_tr2_td6') }}</td>
              </tr>
            </tbody>
          </table>

          <!--          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td1') }}</td>
                <td>{{ $t('noble_table1_tr4_td1') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td2') }}</td>
                <td>{{ $t('noble_table1_tr4_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td3') }}</td>
                <td>{{ $t('noble_table1_tr4_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td4') }}</td>
                <td>{{ $t('noble_table1_tr3_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('noble_table1_tr1_td5') }}</td>
                <td>{{ $t('noble_table1_tr4_td4') }}</td>
              </tr>
              <tr>
                <td class="subTable3">{{ $t('noble_table1_tr1_td6') }}</td>
                <td>{{ $t('noble_table1_tr2_td6') }}</td>
              </tr>
            </tbody>
          </table>-->
        </div>
      </div>
    </div>
    <div class="container">
      <div class="rowSpace"><hr /></div>
      <div class="row d-flex justify-content-center">
        <!--        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('noble_addition_title') }}</div>

          <GallerySlideCarousels :slides="addition_slides" :slide-count="4" :thumb-slide-width="50" />

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('noble_table2_tr1_td1') }}</td>
                <td colspan="2">{{ $t('noble_table2_tr1_td2') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('noble_table2_tr2_td1') }}</td>
                <td>{{ $t('noble_table2_tr2_td2') }}</td>
                <td rowspan="5">{{ $t('noble_table2_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('noble_table2_tr3_td1') }}</td>
                <td>{{ $t('noble_table2_tr3_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('noble_table2_tr4_td1') }}</td>
                <td>{{ $t('noble_table2_tr4_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('noble_table2_tr5_td1') }}</td>
                <td>{{ $t('noble_table2_tr5_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('noble_table2_tr6_td1') }}</td>
                <td>{{ $t('noble_table2_tr6_td2') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="rowSpace"><hr /></div>-->
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('noble_etc_title') }}</div>
          <div class="subDetail">
            <div>{{ $t('noble_etc_desc1') }}</div>
            <div>{{ $t('noble_etc_desc2') }}</div>
            <div>{{ $t('noble_etc_desc3') }}</div>
            <div>{{ $t('noble_etc_desc4') }}</div>
            <div>{{ $t('noble_etc_desc5') }}</div>
            <!--            <div>{{ $t('noble_etc_desc6') }}</div>-->
            <div>{{ $t('noble_etc_desc7') }}</div>
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <!--          <router-link to="/p/Reservpleisure/2" class="resserve-button"> 예약신청 </router-link>-->
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P003'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'nobleriding',
  data() {
    return {
      isLang: 0,
      program_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/program/nobleriding_main_01.jpg')},
        {image: require('@/assets/images/pleisure/program/nobleriding_main_02.jpg')},
        {image: require('@/assets/images/pleisure/program/nobleriding_main_03.jpg')},
      ],
      addition_slides: [
        {image: require('@/assets/images/pleisure/program/nobleriding_option_01.jpg')},
        {image: require('@/assets/images/pleisure/program/nobleriding_option_02.jpg')},
        {image: require('@/assets/images/pleisure/program/nobleriding_option_03.jpg')},
        {image: require('@/assets/images/pleisure/program/nobleriding_option_04.jpg')},
        {image: require('@/assets/images/pleisure/program/vonestis_option_01.jpg')},
      ],
      sub_items: [
        {
          title: 'noble_mainp_title1',
          desc: 'noble_mainp_desc1',
          image: require('@/assets/images/pleisure/program/nobleriding_main_01.jpg'),
        },
        {
          title: 'noble_mainp_title2',
          desc: 'noble_mainp_desc2',
          image: require('@/assets/images/pleisure/program/nobleriding_main_02.jpg'),
        },
        /*{
          title: 'noble_mainp_title3',
          desc: 'noble_mainp_desc3',
          image: require('@/assets/images/pleisure/program/nobleriding_main_03.jpg'),
        },*/
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
td {
  vertical-align: middle;
}
.top {
  padding-top: 11rem;
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
      word-break: keep-all;
    }
  }
}

.subTable2 {
  font-weight: bold;
}
.subTable3 {
  background-color: #f3f3f3;
  font-weight: bold;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/pleisure/program/nobleriding_headerimage.jpg');
}

@media (min-width: 992px) {
  .web {
  }

  .mobile {
    display: none;
  }
  .card {
    height: 26rem;
  }
}

@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }

  .web {
    display: none;
  }

  .mobile {
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프로그램 안내",
    "noble_title": "노블 승마",
    "noble_subtitle": "전문 교관의 정통 승마강습부터 외승 체험까지",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "noble_desc1": "초보자부터 상급자까지 고객별 맞춤 전문 승마 강습 프로그램.",
    "noble_desc2": "우수한 승마 클럽에서 즐기는 실내 승마와 제주 자연을 온전히 느낄 수 있는 특별한 외승주로까지.",
    "noble_desc3": "멋진 명마를 타고 제주의 또 다른 즐거움을 느껴 보시기 바랍니다.",
    "noble_desc4": "※ 연령제한 6세 이상",
    "noble_desc5": "※ 개인별 필수 준비사항 : 긴 바지, 편한 신발",
    "noble_desc6": "※ 매주 월요일 휴장",
    "noble_common_title": "공통 의전 및 서비스",
    "noble_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "noble_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "noble_common_desc3": "- 어메니티, 미니바 제공",
    "noble_common_desc4": "- F&B 세트 제공",
    "noble_main_title": "메인 프로그램",
    "noble_mainp_title1": "실내&실외 승마",
    "noble_mainp_desc1": "정통승마강습(30분) + 야외트랙 탑승(30분)",
    "noble_mainp_title2": "실내 승마",
    "noble_mainp_desc2": "정통승마강습(60분)",
    "noble_mainp_title3": "키즈 승마",
    "noble_mainp_desc3": "전문 교관과 함께하는 포니(Pony) 탑승(60분)",
    "noble_table1_tr1_td1": "옵션",
    "noble_table1_tr1_td2": "시간",
    "noble_table1_tr1_td3": "최대인원",
    "noble_table1_tr1_td4": "소요시간",
    "noble_table1_tr1_td5": "요금(2인기준)",
    "noble_table1_tr1_td6": "추가옵션",
    "noble_table1_tr2_td1": "실내&실외 승마",
    "noble_table1_tr2_td2": "60분",
    "noble_table1_tr2_td3": "4인",
    "noble_table1_tr2_td4": "2H",
    "noble_table1_tr2_td5": "800,000",
    "noble_table1_tr2_td6": "※ 인원추가 +150,000 원 / 인",
    "noble_table1_tr3_td1": "실내승마",
    "noble_table1_tr3_td2": "60분",
    "noble_table1_tr3_td3": "2 ~ 2.5H",
    "noble_table1_tr3_td4": "800,000",
    "noble_table1_tr4_td1": "키즈승마",
    "noble_table1_tr4_td2": "60분",
    "noble_table1_tr4_td3": "2인(탑승자 기준)",
    "noble_table1_tr4_td4": "800,000",
    "noble_addition_title": "추가옵션",
    "noble_table2_tr1_td1": "구분",
    "noble_table2_tr1_td2": "옵션(2인기준)",
    "noble_table2_tr2_td1": "150,000",
    "noble_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분), 스냅(승마)",
    "noble_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "noble_table2_tr3_td1": "200,000",
    "noble_table2_tr3_td2": "메디컬 스파(바디)",
    "noble_table2_tr4_td1": "350,000",
    "noble_table2_tr4_td2": "오모로비짜 스파(90분)",
    "noble_table2_tr5_td1": "400,000",
    "noble_table2_tr5_td2": "본에스티스 스파(90분)",
    "noble_table2_tr6_td1": "플라워 세팅",
    "noble_table2_tr6_td2": "300,000 / 500,000 / 700,000",
    "noble_etc_title": "기타사항",
    "noble_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "noble_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "noble_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "noble_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "noble_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "noble_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "noble_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  },
  "en": {
    "breadcrumb": "Program Information",
    "noble_title": "Noble riding",
    "noble_subtitle": "Authentic horseback riding lesson and outdoor riding experience.",
    "prev_button": "Previous",
    "reserve_button": "Book Now",
    "noble_desc1": "Special horseback riding lesson programs tailored to the customer from beginners to seniors.",
    "noble_desc2": "Enjoy the indoor horseback riding at the premium riding club and a special outdoor riding track where you can fully feel the nature of Jeju Island.",
    "noble_desc3": "You can experience a special fun moment in Jeju, as riding a beautiful horse.",
    "noble_desc4": "※ Available only for 6 years old or older",
    "noble_desc5": "※ Required items: long pants, comfortable shoes",
    "noble_desc6": "※ Closed every Monday",
    "noble_common_title": "Common escort service and other services",
    "noble_common_desc1": "- Escort vehicle service (Benz Sprinter / Carnival High Limousine)",
    "noble_common_desc2": "- Care service by the PINX escort manager",
    "noble_common_desc3": "- Free amenities and minibar",
    "noble_common_desc4": "- Complimentary F&B sets",
    "noble_main_title": "Main Program",
    "noble_mainp_title1": "Indoor & Outdoor horseback riding",
    "noble_mainp_desc1": "Authentic horseback riding lesson(30 minutes) + outdoor track (30 minutes)",
    "noble_mainp_title2": "Indoor horseback riding",
    "noble_mainp_desc2": "Authentic horseback riding lesson(60 minutes)",
    "noble_mainp_title3": "Kids lesson",
    "noble_mainp_desc3": "Pony riding with a professional instructor (60 minutes)",
    "noble_table1_tr1_td1": "Option",
    "noble_table1_tr1_td2": "Running time",
    "noble_table1_tr1_td3": "Maximum Occupancy",
    "noble_table1_tr1_td4": "Total time",
    "noble_table1_tr1_td5": "Fare(2 people)",
    "noble_table1_tr1_td6": "Additional option",
    "noble_table1_tr2_td1": "Indoor & Outdoor horseback riding",
    "noble_table1_tr2_td2": "60 min",
    "noble_table1_tr2_td3": "4 people",
    "noble_table1_tr2_td4": "2H",
    "noble_table1_tr2_td5": "KRW 800,000",
    "noble_table1_tr2_td6": "※ Additional person + KRW 150,000 / 1 person",
    "noble_table1_tr3_td1": "Indoor horseback riding",
    "noble_table1_tr3_td2": "60 min",
    "noble_table1_tr3_td3": "2 ~ 2.5H",
    "noble_table1_tr3_td4": "KRW 800,000",
    "noble_table1_tr4_td1": "Kids horseback riding",
    "noble_table1_tr4_td2": "60 min",
    "noble_table1_tr4_td3": "2 kids",
    "noble_table1_tr4_td4": "KRW 800,000",
    "noble_addition_title": "Additional options",
    "noble_table2_tr1_td1": "Fare",
    "noble_table2_tr1_td2": "Option(2 person)",
    "noble_table2_tr2_td1": "KRW 150,000",
    "noble_table2_tr2_td2": "Water therapy, Shooting, Omorovicza Spa(40min.), Snapshot(horse riding)",
    "noble_table2_tr2_td3": "※ More than 3 people, please contact us",
    "noble_table2_tr3_td1": "KRW 200,000",
    "noble_table2_tr3_td2": "Medical Spa(Body)",
    "noble_table2_tr4_td1": "KRW 350,000",
    "noble_table2_tr4_td2": "Omorovicza Spa(90 min)",
    "noble_table2_tr5_td1": "KRW 400,000",
    "noble_table2_tr5_td2": "Vonestis Spa(90 min)",
    "noble_table2_tr6_td1": "Flower service",
    "noble_table2_tr6_td2": "KRW 300,000 / 500,000 / 700,000",
    "noble_etc_title": "Others",
    "noble_etc_desc1": "※ A fare applies for children aged 5 or older.",
    "noble_etc_desc2": "※ In some cases, minors may need a guardian.",
    "noble_etc_desc3": "※ The company’s cancellation policy shall apply in the case of cancellation or refund due to a simple change in mind.",
    "noble_etc_desc4": "- Penalty will be charged 0% until 7 days prior to the reserved date, 30% from 5 to 6 days before, 50% until 4 days before, 70% until 2 to 3 days before (by 5pm), and no refund will be made(100% penalty) after 5pm 2 days prior to the reserved date.",
    "noble_etc_desc5": "※ In case of cancellation due to natural disasters or unavoidable circumstances due to the company's operational reason, the cancellation policy shall not apply.",
    "noble_etc_desc6": "※ Traveler's insurance is included in the product.",
    "noble_etc_desc7": "※ Contact us by phone for the group of people other than the number in the price list."
  },
  "ja": {
    "breadcrumb": "프로그램 안내",
    "noble_title": "노블 승마",
    "noble_subtitle": "전문 교관의 정통 승마강습부터 외승 체험까지",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "noble_desc1": "초보자부터 상급자까지 고객별 맞춤 전문 승마 강습 프로그램.",
    "noble_desc2": "우수한 승마 클럽에서 즐기는 실내 승마와 제주 자연을 온전히 느낄 수 있는 특별한 외승주로까지.",
    "noble_desc3": "멋진 명마를 타고 제주의 또 다른 즐거움을 느껴 보시기 바랍니다.",
    "noble_desc4": "※ 연령제한 6세 이상",
    "noble_desc5": "※ 개인별 필수 준비사항 : 긴 바지, 편한 신발",
    "noble_desc6": "※ 매주 월요일 휴장",
    "noble_common_title": "공통 의전 및 서비스",
    "noble_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "noble_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "noble_common_desc3": "- 어메니티, 미니바 제공",
    "noble_common_desc4": "- F&B 세트 제공",
    "noble_main_title": "메인 프로그램",
    "noble_mainp_title1": "실내&실외 승마",
    "noble_mainp_desc1": "정통승마강습(30분) + 야외트랙 탑승(30분)",
    "noble_mainp_title2": "실내 승마",
    "noble_mainp_desc2": "정통승마강습(60분)",
    "noble_mainp_title3": "키즈 승마",
    "noble_mainp_desc3": "전문 교관과 함께하는 포니(Pony) 탑승(60분)",
    "noble_table1_tr1_td1": "옵션",
    "noble_table1_tr1_td2": "시간",
    "noble_table1_tr1_td3": "최대인원",
    "noble_table1_tr1_td4": "소요시간",
    "noble_table1_tr1_td5": "요금(2인기준)",
    "noble_table1_tr1_td6": "비고",
    "noble_table1_tr2_td1": "실내&실외 승마",
    "noble_table1_tr2_td2": "60분",
    "noble_table1_tr2_td3": "4인",
    "noble_table1_tr2_td4": "2H",
    "noble_table1_tr2_td5": "800,000",
    "noble_table1_tr2_td6": "※ 인원추가 +150,000 원 / 인",
    "noble_table1_tr3_td1": "실내승마",
    "noble_table1_tr3_td2": "60분",
    "noble_table1_tr3_td3": "2 ~ 2.5H",
    "noble_table1_tr3_td4": "800,000",
    "noble_table1_tr4_td1": "키즈승마",
    "noble_table1_tr4_td2": "60분",
    "noble_table1_tr4_td3": "2인(탑승자 기준)",
    "noble_table1_tr4_td4": "800,000",
    "noble_addition_title": "추가옵션",
    "noble_table2_tr1_td1": "구분",
    "noble_table2_tr1_td2": "옵션(2인기준)",
    "noble_table2_tr2_td1": "150,000",
    "noble_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분), 스냅(승마)",
    "noble_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "noble_table2_tr3_td1": "200,000",
    "noble_table2_tr3_td2": "메디컬 스파(바디)",
    "noble_table2_tr4_td1": "350,000",
    "noble_table2_tr4_td2": "오모로비짜 스파(90분)",
    "noble_table2_tr5_td1": "플라워 세팅",
    "noble_table2_tr5_td2": "300,000 / 500,000 / 700,000",
    "noble_etc_title": "기타사항",
    "noble_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "noble_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "noble_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "noble_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "noble_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "noble_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "noble_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  }
}
</i18n>
